// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 824) return "static/chunks/824-0b37b2947ba8d1c9.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"113":"eb145b715b5a8180","149":"501c1f8c2e0d3a6b"}[chunkId] + ".js";
};